import useAppContext from 'flow/hooks/useAppContext';
import CardCallDetailsContainer from 'flow/components/pbx/v2/misc/CardCallDetailsContainer';
import SkeletonSummary from './SkeletonSummary';

const CardTranscriptionPending = () => {
    const { i18next } = useAppContext();

    return (
        <CardCallDetailsContainer className="flex-col gap-1">
            <span className="animate-ellipsis text-sm font-bold antialiased">
                {i18next.t('ai.transcript.transcribing_call')}
            </span>
            <SkeletonSummary />
        </CardCallDetailsContainer>
    );
};

export default CardTranscriptionPending;
